import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { testConfig } from '../../docs-routes'

const ScriptedTestConfigScenarioTagsDescription = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      Use SenseTalk syntax to apply scenario tags to all the features in your test config, to specify which scenarios in your feature files to run. All scenarios are selected if no tag is applied.
    </Color>
    <LinkToDocusaurus path={testConfig}>
      Learn more in the DAI documentation
    </LinkToDocusaurus>
  </Paragraph>

export default ScriptedTestConfigScenarioTagsDescription
